module.exports = __webpack_public_path__ + "img/snackbar-error.37dd2ce9.svg";